import React, { Suspense } from 'react';

import { BaseLoader } from '@savgroup-front-common/core/src/molecules/BaseLoader';

import { FileSectionSummary } from './components/FileSectionSummary/FileSectionSummary';
import { OrderSectionSummary } from './components/OrderSectionSummary/OrderSectionSummary';
import { OwnerSectionSummary } from './components/OwnerSectionSummary/OwnerSectionSummary';
import SummaryRefundHistory from './components/SummaryRefundHistory/SummaryRefundHistory';
import { useGetFileSummaryNewUi } from './FileSummaryNewUi.hooks';
import { $FileSummarySections } from './FileSummaryNewUi.styles';

export const FileSummaryNewUi: React.FC = () => {
  const { data, isLoading } = useGetFileSummaryNewUi();

  if (!data || isLoading) {
    return <BaseLoader />;
  }

  return (
    <Suspense fallback={<BaseLoader />}>
      <$FileSummarySections>
        <OwnerSectionSummary />
        <OrderSectionSummary />
        <FileSectionSummary
          createdDate={data.createdDate}
          actorId={data.fullSummary.actorId}
          siteActorId={data.fullSummary.siteActorId}
          siteActorType={data.fullSummary.siteActorType}
          sellerId={data.context.sellerId}
          owner={data.owner}
          storeActorId={data.fullSummary.storeActorId}
          actorType={data.fullSummary.actorType}
        />
      </$FileSummarySections>
      <SummaryRefundHistory />
    </Suspense>
  );
};

FileSummaryNewUi.displayName = 'FileSummaryNewUi';
